export type Coach = {
  name: string
  role: string
  avatar: string
}

/**
 * PLACEHOLDER coaches for the hero row and review cards.
 * Replace names, roles and photos with real buyers before running traffic.
 */
export const coaches: Coach[] = [
  {
    name: 'Coach name',
    role: 'Rec center coach · City, TX',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/3e86acb3-07c0-4cf1-a87f-3d1e9a9be222.jpg',
  },
  {
    name: 'Coach name',
    role: 'Club instructor · City, UK',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/2148db2d-3628-44f3-bcff-d832a5b2f0e3.jpg',
  },
  {
    name: 'Coach name',
    role: 'Community clinic coach · City, AU',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/89c65b41-93e3-417e-a119-d1945552a0d6.jpg',
  },
  {
    name: 'Coach name',
    role: 'Volunteer coach · City, ON',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/b0089101-b62a-474b-9699-7a348b8e821a.jpg',
  },
  {
    name: 'Coach name',
    role: 'Independent coach · City, FL',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/a146207e-2e76-47e2-9b9a-1499ea1f25c1.jpg',
  },
]
